/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */


/**
 * Cabin
 */
export enum Cabin {
  ECONOMY = 'ECONOMY',
  ECOPREMIUM = 'ECOPREMIUM',
  BUSINESS = 'BUSINESS',
  FIRST = 'FIRST',
  MIXED = 'MIXED'
}

